module.exports = __webpack_public_path__ + "static/media/details-3-image-2.fd80d977.jpg";